import {Dialog, DialogTitle} from "@mui/material";

import "./style.css";

const CustomizedConfirmDialog = (props) => {
    const {open, title, confirmBtnLabel, cancelBtnLabel, onCancel, onConfirm, children} = props

    return <Dialog open={open}>
        <DialogTitle sx={{textAlign: 'center', fontWeight: 'bold'}}>{title}</DialogTitle>
        <div className="dialog-body-container">
            {children}
            <div className="action-btn-container">
                <button className="cancel-btn" onClick={onCancel}>{cancelBtnLabel}</button>
                <button className="confirm-btn" onClick={onConfirm}>{confirmBtnLabel}</button>
            </div>
        </div>
    </Dialog>
}

export default CustomizedConfirmDialog;